import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { USER_ADD_SUCCESS } from './user.actions';
import { NgxPermissionsService } from 'ngx-permissions';
import { map, tap } from 'rxjs/operators';
import { User } from './user';

@Injectable()
export class UserEffects {
  @Effect({ dispatch: false })
  userAddSuccess$: Observable<User> = this.actions$.pipe(
    ofType(USER_ADD_SUCCESS),
    map((action: any) => action.payload),
    tap((user: User) => {
      this.permissionsService.loadPermissions(user.permissions);
    })
  );

  constructor(private actions$: Actions, private permissionsService: NgxPermissionsService) {}
}
